// At least minDaysOff per calendar week.
// Uses day-work indicators w_{u,day} and groups days by Monday-key week.
// Params: { minDaysOff: number } default 2
export function buildMediaWeeklyDaysOffConstraints(model, params = {}) {
  const idx = model?.optimizationIndexes || {};
  const users = Object.keys(idx.users || {});
  const dayKeys = Array.isArray(idx.dayKeys) ? idx.dayKeys.slice() : [];
  const wDeclared = new Set(Object.keys(idx.dayWorkDecisionVariables || {}));
  const minDaysOff = Number(params?.minDaysOff) >= 0 ? Number(params.minDaysOff) : 2;

  if (!dayKeys.length || !users.length) return [];

  const weekKeyFromYmd = (ymd) => {
    const [y, m, d] = String(ymd || '').split('-').map((n) => Number(n));
    if (!Number.isFinite(y) || !Number.isFinite(m) || !Number.isFinite(d)) return null;
    const dt = new Date(y, m - 1, d);
    const day = dt.getDay(); // 0=Sun..6=Sat
    const diffSinceMonday = (day + 6) % 7;
    const monday = new Date(dt);
    monday.setDate(dt.getDate() - diffSinceMonday);
    monday.setHours(0, 0, 0, 0);
    const pad = (n) => String(n).padStart(2, '0');
    return `${monday.getFullYear()}-${pad(monday.getMonth() + 1)}-${pad(monday.getDate())}`;
  };

  const daysByWeek = new Map(); // weekKey -> [ymd]
  for (const ymd of dayKeys) {
    const wk = weekKeyFromYmd(ymd);
    if (!wk) continue;
    if (!daysByWeek.has(wk)) daysByWeek.set(wk, []);
    daysByWeek.get(wk).push(ymd);
  }

  const constraints = [];
  for (const [, days] of daysByWeek.entries()) {
    const totalDays = days.length;
    const maxWorkDays = Math.max(0, totalDays - minDaysOff);
    for (const uKey of users) {
      const vars = [];
      for (const d of days) {
        const wName = `w_${uKey}_${d}`;
        if (wDeclared.has(wName)) vars.push(wName);
      }
      if (!vars.length) continue;
      const coeffs = vars.map(() => 1);
      constraints.push({ linear: { vars, coeffs }, domain: [-100000, maxWorkDays] });
    }
  }

  return constraints;
}

